import submarine from './Submarine/Beef Spicy Submarine.png'
import rice from "./Biriyani/Chicken Biriyani.png";
import juice from "./Juice/faluda.png";
import iceCream from './Ice Cream/Strawberry Special.png'
import kottu from './Kottu/Cheese Kottu.png'
import shawarma from './Shawarma/Chicken Shawarma.png'
import burger from './Burger/Hot Spicy Burger.png'

let categories = [
    {
        item_category:"rice",
        category_image: rice
    },
    {
        item_category:"kottu",
        category_image:kottu
    },
    {
        item_category:"juice",
        category_image:juice
    },
    {
        item_category:"icecream",
        category_image:iceCream
    },
    {
        item_category:"shawarma",
        category_image:shawarma
    },
    {
        item_category:"burger",
        category_image:burger
    },
    {
        item_category:"submarine",
        category_image:submarine
    }
]

export default categories